import {useSelector} from 'react-redux';
import {ReduxState} from '../../../../store/types';
import Loader from '../../../../components/Loader/Loader';
import React, {useEffect} from 'react';
import PlanForm from '../../../../components/Forms/Extensions/PlanForm';
import {useAccountPlanFormData} from '../../../../hooks/useAccountPlanFormData';
import {useTabStyles} from '../../../Extensions/ExtensionDetails/utils';
import {MainProductType} from '../../../../components/Extensions/MainProductSelectFiled/utils';
import {Formik} from 'formik';
import {
    extensionPlanFormDefaultValues,
    ExtensionPlanFormType,
    extensionPlanFormValidationSchema,
} from '../../../../components/Forms/Extensions/PlanForm.utils';
import {TabInterface} from '../../../../components/Tabs/Tabs.utils';

interface PlanTabInterface extends TabInterface {
    productType: MainProductType;
}

const PlanTab: React.VFC<PlanTabInterface> = (
    {
        handleSubmitForm,
        productType,
        handleInitDataChange,
        handleDirtyChange,
        handleSetSubmitFunc,
        handleSetIsValidFunc,
        isActive,
        tabName,
        tabIndex
    }) => {
    const classes = useTabStyles();

    const isDataLoading = useSelector(
        (state: ReduxState) =>
            state.accounts.accountDetails?.isFormDataLoading || false,
    );

    const {data, initFormData} = useAccountPlanFormData();

    useEffect(() => {
        if (!isDataLoading && initFormData) {
            handleInitDataChange?.(initFormData);
            handleSubmitForm?.(initFormData);
        }
    }, [isDataLoading, initFormData?.selectedMainProduct]);

    return isDataLoading ? (
        <div className={classes.loader}>
            <Loader dataQa="account-plan-loader"/>
        </div>
    ) : (
        <Formik<ExtensionPlanFormType>
            initialValues={initFormData ?? extensionPlanFormDefaultValues}
            enableReinitialize={true}
            validationSchema={extensionPlanFormValidationSchema}
            validateOnChange={false}
            onSubmit={handleSubmitForm!}
        >{() => {

            return (
                <>
                    <PlanForm
                        i_account={data.i_account}
                        productType={productType}
                        handleDirtyChange={handleDirtyChange}
                        handleSetSubmitFunc={handleSetSubmitFunc}
                        handleSetIsValidFunc={handleSetIsValidFunc}
                        tabName={tabName}
                        tabIndex={tabIndex}
                    />
                </>
            )
        }

        }

        </Formik>
    );
};

export default PlanTab;